import { db } from './firebase.js';
import { doc, getDoc } from 'firebase/firestore';

export async function fetchMythicsData() {
  const snap = await getDoc(doc(db, 'mythics', 'latest'));
  if (!snap.exists()) return { nfts: [] };
  return snap.data();
}
